import React from 'react';
import './miert_velunk.css';
import { Footer } from '../footer/footer';

function MiertVelunk() {
  return (
    <div className="miert-velunk-container">
      <header className="hero-section">
        <h1>Császár Travel - Az élmenyek útján</h1>
        <p>
    
        </p>
      </header>

      <section className="benefits-section">
        <div className="benefit">
          <h2>Küldetésünk és Szenvedélyünk</h2>
          <p>
          A Császár Travel egy lendületes és megbízható utazási iroda, amely Lenti szívéből kínál belföldi és külföldi buszos kirándulásokat – egy- és többnapos formában. Szenvedélyünk az utazás és az élményszerzés.
</p>
        </div>

        <div className="benefit">
          <h2>Széles Úti Cél Kínálat</h2>
          <p>
          Legyen szó városlátogatásról, természeti csodák felfedezéséről, tengerparti nyaralásról vagy különleges kulturális programról, nálunk mindenki megtalálja a számára ideális úti célt.
          </p>
        </div>

        <div className="benefit">
          <h2>Kényelem és Biztonság</h2>
          <p>
          Célunk, hogy utasaink biztonságban, jó társaságban és maximális kényelemben juthassanak el álmaik helyszínére. Útjaink során minden részletre odafigyelünk.
          </p>
        </div>

        <div className="benefit">
          <h2>Profi Idegenvezetés és Gondoskodás</h2>
          <p>
          Saját szervezésű buszos útjaink során profi idegenvezetésről és a gördülékeny szervezésről gondoskodunk, hogy minden pillanat emlékezetes legyen.
          </p>
        </div>

        <div className="benefit">
          <h2>Folyamatosan Frissülő Kínálat</h2>
          <p>
          A weboldalon állandóan frissülő kínálattal, képekkel és részletes programleírásokkal várunk – kövess bennünket, és csatlakozz egy felejthetetlen utazáshoz!
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default MiertVelunk;
